import { MouseEventHandler, useState } from "react";
import { FONT } from "../../value/staticValues";

interface CustomDeleteBtnProps {
    size?: { width?: number; height?: number };
    fontsize?: number;
    text: String;
    disabled?: boolean;
    onPress: MouseEventHandler;
}

export function CustomDeleteBtn(props:CustomDeleteBtnProps) {
    const [mouseState, setMouseState] = useState(false);

    return (
        <div
            style={{
                width: props.size?.width || 70, minWidth: 70,
                height: props.size?.height || 36, minHeight: 36,
                display: "flex", justifyContent: "center", alignItems: "center",
                borderRadius: 10,
                backgroundColor: props.disabled ? "#dcdfe6" : mouseState? "#626366" : "#9ea0a5",
                fontFamily: FONT.MEDIUM,
                fontSize: props.fontsize? props.fontsize : 12,
                color: "#fff",
                cursor: props.disabled ? "initial" : "pointer",
            }}
            onMouseOut={() => {
                setMouseState(false);
            }}
            onMouseOver={() => {
                setMouseState(true);
            }}
            onClick={(e)=>{if(!props.disabled) props.onPress(e);}}
        >
            {props.text}
        </div>
    )
}
